// Components
import SelectedTextModal from '../Modals/ThemesAdd.vue'; // used by ResponseList
import CreateNoteModal from '../Modals/CreateNote.vue';

export default {
  data() {
    return {
      selection: null,
      isSelectedTextModalVisible: false,
      isCreateNoteModalVisible: false,
      selectedTextModalType: 'keyword',
      selectedTextModalResponseId: '',
    };
  },
  components: {
    SelectedTextModal,
    CreateNoteModal,
  },
  methods: {
    onKeyword(selection) {
      this.selection = selection;
      this.isSelectedTextModalVisible = true;
      this.selectedTextModalType = 'keyword';
    },
    onNote(selection) {
      this.selection = selection;
      this.isCreateNoteModalVisible = true;
    },
    onSearch(selection) {
      this.$root.$emit('search-keyword', selection.content.trim());
    },
    closeModal() {
      this.isSelectedTextModalVisible = false;
      this.isCreateNoteModalVisible = false;
      // reset to default
      this.selectedTextModalType = 'keyword';
    },
  },
};
